import { apiToken, filesUrl } from "../config";

// upload file start 

export const uploadFile = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch(filesUrl, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${apiToken}`,
            },
            body: formData,
        });

        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || 'File upload failed');
        }

        return res;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error || new Error('File upload failed');
    }
};

// upload file end

// get all files start

export const getAllFiles = async (params = {}) => {
    try {
        const url = new URL(filesUrl);
        const query = {
            page: params.page || 1,
            limit: params.limit || 10,
        }
        Object.keys(query).forEach((key) => {
            if (query[key]) url.searchParams.append(key, query[key]);
        })

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${apiToken}`
            }
        });

        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || 'Failed to fetch files');
        }
        return res;
    } catch (e) {
        throw new Error(e.message || "Something went wrong");
    }
}

// get all file end

// get file by id start

export const getFileById = async (fileId) => {
    try {
        const response = await fetch(`${filesUrl}/${fileId}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${apiToken}`
            }
        });

        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || 'Failed to fetch file');
        }
        return res;
    } catch (e) {
        throw new Error(e.message || "Something went wrong");
    }
}

// get files by id end

// delete file by id start

export const deleteFileById = async (fileId) => {
    try {
        const response = await fetch(`${filesUrl}/${fileId}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${apiToken}`
            }
        });

        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || 'Failed to delete file');
        }
        return res;
    } catch (e) {
        throw new Error(e.message || "Something went wrong");
    }
}

// delete files by id end

